<template>
  <v-card v-if="data" :class="['bc-album']">
    <v-card-text>
      <div :class="['px-2']">
        <v-progress-linear v-if="loading" height="4" indeterminate :color="$config.colors.primary" />
      </div>
      <template v-if="!loading">
        <v-layout row wrap v-if="mode === 'artist'">
          <v-flex lg12 md12 sm12 xs12 :class="['pa-2']">
            <h3 :class="[`${$config.colors.primary}--text`, 'font-weight-light', 'title', 'py-2', 'text-xs-center']" v-html="data.title" />
            <v-divider />
            <p v-html="data.bio" :class="['ma-0', 'pt-4', 'text-xs-center']" />
          </v-flex>
          <v-flex @click="getAlbum(album.slug)" lg3 md3 sm6 xs12 v-for="(album, index) in data.albums" :key="index" :class="['pa-2', 'clickable']">
            <v-img :title="$lang.viewAlbum" :src="album.art" :class="['elevation-8', 'mt-2']" />
            <v-btn small block :color="$config.colors.primary" aria-label="view-album" dark>
              {{ $lang.viewAlbum }}&nbsp;<v-icon small>mdi-chevron-double-right</v-icon>
            </v-btn>
          </v-flex>
          <v-flex lg12 md12 sm12 xs12 :class="['pa-2']">
            <view-on-bandcamp :href="data.url" :class="['text-xs-center']" />
          </v-flex>
        </v-layout>
        <v-layout row wrap v-if="mode === 'album' && data.artist">
          <v-flex lg6 md6 sm6 xs12 :class="['pa-2']">
            <h4 v-html="data.title" :class="['font-weight-light', 'title', 'pb-2', 'text-xs-center']" />
            <v-divider :class="['my-2']" />
            <h5 v-html="data.artist" :title="$lang.backToDiscography" @click="getArtist" :class="[`${$config.colors.primary}--text`, 'text-xs-center', 'font-weight-light', 'title', 'py-2', 'clickable']" />
            <v-card>
              <v-card-text>
                <v-list>
                  <template v-for="(track, index) in data.tracks">
                    <v-list-tile :key="index" @click="getTrack(track.slug)">
                      <v-list-tile-avatar>
                        <v-icon>mdi-music-note</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>{{ track.title }}</v-list-tile-title>
                        <v-list-tile-sub-title>{{ track.length }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <v-icon>mdi-chevron-double-right</v-icon>
                      </v-list-tile-action>
                    </v-list-tile>
                    <v-divider :key="`${index}-divider`" />
                  </template>
                </v-list>
                <view-on-bandcamp :href="data.url" :class="['text-xs-center', 'py-4']" />
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex lg6 md6 sm6 xs12 :class="['pa-2', 'text-xs-center']">
            <p v-html="data.about" />
            <v-img :src="data.art" :class="['elevation-8']" />
            <p v-html="data.credits" :class="['pt-4']" />
          </v-flex>
        </v-layout>
        <v-layout row wrap v-if="mode === 'track' && data.title">
          <v-flex lg6 md6 sm6 xs12 :class="['pa-2', 'text-xs-center']">
            <h4 v-html="data.title" :class="['font-weight-light', 'title', 'pb-2', 'text-xs-center']" />
            <v-divider :class="['my-2']" />
            <h4 v-html="data.album.title" :title="$lang.viewAlbum" @click="getAlbum(data.album.slug)" :class="['font-weight-light', 'subtitle', 'pb-2', 'text-xs-center', 'clickable']" />
            <h5 v-html="data.artist" :title="$lang.backToDiscography" @click="getArtist" :class="[`${$config.colors.primary}--text`, 'text-xs-center', 'font-weight-light', 'title', 'py-2', 'clickable']" />
            <p v-html="data.about" :class="['pt-2']" />
            <p v-html="data.credits" :class="['pt-2']" />
            <iframe :class="['embed-iframe']" seamless :src="data.embed" />
            <view-on-bandcamp :href="data.url" />
          </v-flex>
          <v-flex lg6 md6 sm6 xs12 :class="['pa-2']">
            <v-img :src="data.art" :class="['elevation-8']" />
          </v-flex>
        </v-layout>
      </template>
    </v-card-text>
  </v-card>
</template>
<script>
import ViewOnBandcamp from '../components/view-on-bandcamp'

export default {
  name: 'BcArtist',
  components: {
    ViewOnBandcamp
  },
  data () {
    return {
      url: `${this.$config.apiRoot}/`,
      data: null,
      mode: 'artist',
      album: null,
      loading: false
    }
  },
  props: {
    artist: {
      type: String,
      required: true
    }
  },
  mounted () {
    this.getArtist()
  },
  methods: {
    getArtist () {
      this.mode = 'artist'
      this.loading = true
      this.$http({
        url: this.url + this.mode,
        method: 'POST',
        data: {
          artist: this.artist
        }
      }).then(response => {
        this.data = response.data.data
        this.loading = false
      }).catch(error => {
        console.error(error)
        this.loading = false
      })
    },
    getAlbum (album) {
      this.mode = 'album'
      this.loading = true
      this.$http({
        url: this.url + this.mode,
        method: 'POST',
        data: {
          artist: this.artist,
          album
        }
      }).then(response => {
        this.data = response.data.data
        this.loading = false
      }).catch(error => {
        console.error(error)
        this.loading = false
      })
    },
    getTrack (track) {
      this.mode = 'track'
      this.loading = true
      this.$http({
        url: this.url + this.mode,
        method: 'POST',
        data: {
          artist: this.artist,
          track
        }
      }).then(response => {
        this.data = response.data.data
        this.loading = false
      }).catch(error => {
        console.error(error)
        this.loading = false
      })
    }
  }
}
</script>
<style>
.embed-iframe
{
  border: 0;
  width: 100%;
  height: 120px;
}
</style>



// WEBPACK FOOTER //
// src/components/bc-artist.vue